import { render } from "./ManagementIcon.vue?vue&type=template&id=33812b61"
import script from "./ManagementIcon.vue?vue&type=script&lang=js"
export * from "./ManagementIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__